export const environment = {
  baseUrl: 'https://api.dev.stratoak.in/api/',
  socketUrl: 'https://api.dev.stratoak.in',
  backendSecretKey: 'KUNU-VolkovIndia-7777',
  localStorageSecretKey: 'beautiful129*876 Rashmi',
  adminUrl: '/admin',
  appUrl: 'https://dev.stratoak.in',
  clientId: '',
  allowed_countries: ['UK', 'IE', 'AT', 'BE', 'FR', 'DE', 'NL', 'PL'],
  guestUrl: '/guest',
  googlePlaceApiKey: 'AIzaSyAUc5KPygalKXNqkFmLtyL0ZurvXTl4muM',
  aws: {
    region: 'ap-south-1',
    bucketName: 'paperloan',
  },
};
